import AdminTextInput from 'components/atoms/adminTextInput';
import RectangleImageButton from 'components/atoms/rectangleImageButton';
import ContactDataCell from 'components/molecules/contactDataCell';
import {useTheme} from 'contexts/ThemeContext';
import { observer } from 'mobx-react';
import {PersonalData} from 'models/Admin';
import React, {useEffect, useState} from 'react';
import {FlatList, ListRenderItemInfo, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ContactListProps {
  flatListData: PersonalData[];
  onPressDelete: (deletable: PersonalData) => void;
  onFieldEdit: (text: string, index: number, fieldName: string) => void;
}

const ContactDataList = observer((props: ContactListProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const renderItem = (itemProps: ListRenderItemInfo<PersonalData>) => {
    return (
      <ContactDataCell
        itemProps={itemProps}
        onPressDelete={props.onPressDelete}
        onFieldEdit={props.onFieldEdit}
      />
    );
  };

  return (
    <View style={styles.container}>
      <FlatList
        style={styles.flatList}
        renderItem={renderItem}
        scrollEnabled={true}
        data={props.flatListData}
        keyExtractor={(item, index) => item.email + index}
      />
    </View>
  );
});

export default ContactDataList;
